import { render, staticRenderFns } from "./doctors-ranking.vue?vue&type=template&id=d4e8eb34&scoped=true"
import script from "./doctors-ranking.vue?vue&type=script&lang=js"
export * from "./doctors-ranking.vue?vue&type=script&lang=js"
import style0 from "./doctors-ranking.vue?vue&type=style&index=0&id=d4e8eb34&prod&scoped=true&lang=css"
import style1 from "./doctors-ranking.vue?vue&type=style&index=1&id=d4e8eb34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e8eb34",
  null
  
)

export default component.exports